import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
export const GetStarted = () => (
  <div id="get-started" className="section rt-section rt-section--dark d-flex flex-column flex-lg-row flex-column-reverse">
    <div className="text-center ml-4 mt-auto">
      <img id="peeker" alt="" />
    </div>
    <div className="container my-auto h-100 d-flex flex-column align-items-center">
      <div className="h-100 d-flex flex-row">

        <div className="my-auto">
          <h2 className="display-5">Get started</h2>
          <p>RepTool is free to use, with subscriptions available for larger scale users.</p>

          <p>Open the app to start tracking your collection, planning pairings, and exploring genetics.</p>

          <p>If you manage a large collection, subscriptions unlock features designed for higher-volume workflows.</p>

          <p><a className="btn rt-btn-primary text-light" href="https://reptool.app/app/">Open RepTool <FontAwesomeIcon icon={faArrowRight} size="1x" className="my-auto" /></a></p>
        </div>

      </div>
    </div>
  </div>
)

export const Demo = GetStarted